import React, { useState } from "react";
import Slider from "react-slick";
import {
  Box,
  Button,
  Container,
  Typography,
  useMediaQuery,
} from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../css/SliderStyles.css";
import sliderRamdan from "../images/sliderRamdan.png";
import movieslider from "../images/movieslider.png";
import Colors from "./Colors";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import easterslider from "../images/easterslider.jpg";
import vishuSlider from "../images/vishuSlider.png";


const slides = [
  {
    title: "Rapid Riddle",
    subtitle: "Vishu Special!",
    description: "Solve, Play & Win Big Rewards!",
    highlight: "From April 13th to April 15th at 8:30 PM ",
    gradient: "#0c3730",
    dotColor: "#0c3730",
    textColor: "#FFD700",
    image: vishuSlider, // Add image URL or import images locally
  },
  {
    title: "Rapid Riddle",
    subtitle: "Easter Special!",
    description: "Solve, Play & Win Big Rewards!",
    highlight: "From March 5th to April 20th every saturday at 8:30 PM",
    gradient: "#401e37",
    dotColor: "#401e37",
    textColor: "#4A1850",
    image: easterslider,
  },
  {
    title: "Rapid Riddle",
    subtitle: "Movie Special!",
    description: "Solve, Play & Win Big Rewards!",
    highlight: "Every Thursday at 8:00 PM",
    gradient: "#1f1317",
    dotColor: "#1f1317",
    textColor: "#4A1850",
    image: movieslider,
  },
];

const SliderRapidRiddle = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const isMobile = useMediaQuery("(max-width:600px)");

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (oldIndex, newIndex) => {
      setPrevIndex(oldIndex);
      setActiveIndex(newIndex);
    },
    appendDots: (dots) => (
      <ul>
        {dots.map((dot, index) => {
          return React.cloneElement(dot, {
            "data-active": index === activeIndex ? "true" : undefined,
            className: index === prevIndex ? "shrinking" : dot.props.className,
          });
        })}
      </ul>
    ),
  };

  return (
    <Container
      onClick={() => {
        if (!localStorage.getItem("PlayerTocken")) {
          window.location.href = "/player-signin";
        } else {
          window.location.href = "/rapid-riddle-landing";
        }
      }}
      maxWidth={false}
      disableGutters
      sx={{
        width: "92%",
        marginTop: "2%",
        overflow: "visible",
        position: "relative",
        padding: 0,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
        borderRadius: 2,
        "--active-dot-color": slides[activeIndex]?.dotColor || "#0CD6FF",
      }}
    >
      <Slider {...settings} style={{ overflow: "visible" }}>
        {slides.map((slide, index) => (
          <Box
            key={index}
            sx={{
              width: "95%",
              height: 178,
              display: "flex !important",
              alignItems: "center",
              justifyContent: "space-between",
              background: slide.gradient,
              // borderRadius: 2,
              fontSize: 18,
              fontWeight: "bold",
              overflow: "visible",
            }}
          >
            <Box
              sx={{
                width: { xs: "60%", md: "80%" },
                display: "flex",
                flexDirection: { md: "row", xs: "column" },
                height: 178,
                paddingLeft: { xs: "20px", md: 0 },
                justifyContent: { md: "space-between" },
              }}
            >
              <Box
                sx={{
                  width: { xs: "100%", md: "30%" },
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: { xs: "flex-start", md: "center" },
                  gap: { md: "10px", xs: "2px" },
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: { md: "48px", xs: "24px" },
                    fontFamily: "Boogaloo",
                  }}
                >
                  {slide.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "10px", md: "20px" },
                    lineHeight: { xs: "12px", md: "16px" },
                    color: "#fff",
                  }}
                >
                  {slide.description}
                </Typography>
              </Box>

              <Button
                variant="contained"
                sx={{
                  position: "relative",
                  marginTop: "6%",
                  display: { md: "flex", xs: "none" },
                  background: "linear-gradient(135deg, #FFD700, #FF9800)", // Gold-Orange gradient
                  color: "#000",
                  fontWeight: "bold",
                  borderRadius: "12px",
                  height: "40px",
                  width: { xs: "140px", md: "160px" },
                  fontSize: { xs: "12px", md: "18px" },
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  boxShadow: "0 5px 15px rgba(255, 152, 0, 0.4)", // Soft glow effect
                  transform: "rotate(-15deg) translate(10px, 10px)", // Rotate and shift diagonally
                  transition: "all 0.4s ease-in-out",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px", // Space between text and icon
                  "&:hover": {
                    background: "linear-gradient(135deg, #FF9800, #FFD700)", // Reverse gradient on hover
                    transform:
                      "rotate(-15deg) translate(10px, 10px) scale(1.1)", // Slightly enlarge on hover
                    boxShadow: "0 8px 20px rgba(255, 152, 0, 0.6)", // Glow effect increase
                  },
                  "&:active": {
                    transform:
                      "rotate(-15deg) translate(10px, 10px) scale(0.95)", // Click effect
                  },
                }}
              >
                Play Now{" "}
                <PlayArrowIcon sx={{ fontSize: { xs: "16px", md: "22px" } }} />
              </Button>

              <Box
                sx={{
                  width: { md: "35%", xs: "100%" },
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: { xs: "flex-start", md: "center" },
                  gap: { md: "10px", xs: "2px" },
                }}
              >
                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: { xs: "24px", md: "48px" },
                    lineHeight: { xs: "22px", md: "44px" },
                    whiteSpace: "pre-line",
                    color: "#fff",
                  }}
                >
                  {isMobile
                    ? slide.subtitle.split(" ").join("\n")
                    : slide.subtitle}
                </Typography>

                <Typography
                  sx={{
                    fontSize: { xs: "8px", md: "12px" },
                    lineHeight: { xs: "12px", md: "16px" },
                    color: "#fff",
                  }}
                >
                  {slide.highlight}
                </Typography>

                {/* Play Now Button */}
              </Box>
            </Box>

            {/* IMAGE BOX */}
            <Box
              sx={{
                width: { xs: "40%", md: "15%" },
                display: "flex",
                flexDirection: "column",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={slide.image}
                alt={slide.title}
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "100%",
                  objectFit: "cover",
                }}
              />
              <Button
                variant="contained"
                sx={{
                  display: { md: "none", xs: "flex" },
                  background: "linear-gradient(135deg, #FFD700, #FF9800)", // Gold-Orange gradient
                  color: "#000",
                  fontWeight: "bold",
                  borderRadius: "12px",
                  height: "30px",
                  marginTop: "-16px",
                  width: "130px",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  boxShadow: "0 4px 10px rgba(255, 152, 0, 0.4)", // Soft glow effect
                  transition: "all 0.4s ease-in-out",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px", // Space between text and icon
                  "&:hover": {
                    background: "linear-gradient(135deg, #FF9800, #FFD700)", // Reverse gradient on hover
                    transform: "scale(1.05)", // Slightly enlarge on hover
                    boxShadow: "0 6px 15px rgba(255, 152, 0, 0.6)", // Glow effect increase
                  },
                  "&:active": {
                    transform: "scale(0.95)", // Click effect
                  },
                }}
              >
                Play Now <PlayArrowIcon sx={{ fontSize: "18px" }} />
              </Button>
            </Box>
          </Box>
        ))}
      </Slider>
    </Container>
  );
};

export default SliderRapidRiddle;
